// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1xunB","title":"AfterBackImages_title__1C3PN","images":"AfterBackImages_images__16Yyh"};